import {createClient} from '@supabase/supabase-js'
import {supabaseUrl, supabasePublicKey} from '../../config.json';

const supabase = createClient(supabaseUrl, supabasePublicKey)

export default supabase;